import styled from "styled-components"
import { variant } from "styled-system"
import { Flex } from "@xingternal/winery-ui/lib/Flex"

const layoutType = variant({
  key: "contentWidth",
})

const LayoutCenter = styled(Flex)(
  {
    overflowY: "auto",
  },
  layoutType,
)

LayoutCenter.defaultProps = {
  alignItems: "center",
  flexDirection: "column",
  fontSize: 2,
  mx: "auto",
  pb: 5,
  px: 5,
  variant: "fluid",
  width: "100%",
}

export default LayoutCenter
